import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
export const TreeItemAction = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("button", {
        className: classNames("text-pigeon-11 flex h-6 w-6 cursor-pointer items-center justify-center rounded-4 hover:bg-grey-4", className),
        ref: forwardedRef,
        ...restOfProps
    });
});
TreeItemAction.displayName = "TreeItemAction";
